angular.module('am4').factory('safeLogsService', function($log) {
    return {
        log: function(message, error) {
            if (error && error.config && error.config.headers && error.config.headers.Authorization) {
                delete error.config.headers.Authorization;
            }
            $log.error({
                errorMessage: message,
                error: error
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/services/safeLogs.js